
import { Component,ChangeDetectorRef, OnInit, ViewChild } from '@angular/core';
import { NgForm, NgModelGroup } from '@angular/forms';
import { Router, ActivatedRoute} from '@angular/router';
import { Location } from '@angular/common';
import { SystemFunctionsService as Sys } from 'src/app/system-functions.service';
import { ValidatorService } from 'src/app/core/validator.service';
import { CanComponentDeactivate } from 'src/app/core/can-deactivate-guard.service';
import { debounceTime, Subject, Subscription } from "rxjs";
import { UtilityService } from 'src/app/utility.service';
import { ApplicationContextService } from 'src/app/application-context.service';
import { ApiService } from 'src/app/api.service';
import { APIResponseHandlerService } from 'src/app/api-response-handler.service';
import { AppInjector } from 'src/app/app-injector.module';
import { AppConstants } from 'src/app/app-constants';
import { LiquidService } from "src/app/liquid-service/liquid.service";






 import $ from 'jquery';
  
@Component({
  selector: 'ads-container-submissionsuccess',
  templateUrl: './submissionsuccess.component.html'
})
export class SubmissionSuccessComponent implements OnInit, CanComponentDeactivate 
{
  






  public Sys = Sys;
  public AppConstants=AppConstants;
  public subscriptions:Subscription[]=[];
  public debounceObs = new Subject<Function>();
  validationMessages : string[] = [];
  public intervalIds : number[] = [];
  subscription: Subscription = new Subscription();
   canDeactivate(): boolean {
    return !this.SubmissionSuccessForm.dirty;
  }
  @ViewChild('SubmissionSuccessForm') SubmissionSuccessForm: NgForm;

    
  constructor(private router: Router,
              private route: ActivatedRoute, 
              public vs: ValidatorService,
              public us: UtilityService,
              public appContext: ApplicationContextService,
              public apiServc: ApiService,
              private cdr: ChangeDetectorRef,
              public liquidService:LiquidService,
              public apiResponse:APIResponseHandlerService,
              private location: Location,
                            
              
                                            ){       
	this.subscriptions.push(this.debounceObs.pipe(debounceTime(350)).subscribe(fn => fn()));
  }  
    async ngOnInit(){
	try{
		   
	
	}
	catch
	{
	}
}
  
  
  ngOnDestroy(){
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.intervalIds.forEach(intervalId => {
        clearInterval(intervalId)
        })
  }
  ngAfterViewChecked() {
    this.cdr.detectChanges()
  }
}
